/**
 * @ngdoc component
 * @name  common.product.product-view.component:itxProductView
 * @requires ItxScreenSizeSvc
 * @description
 * Product view details component. This component shows the information under the image in the category grid.
 * It's responsable for show the description, price and other things like, more colors leyend or made in, etc.
 * 
 * @param {string} layout 'two-columns' or 'four-columns'. Define the container layout. How it's going to be rendered.
 * @param {string} location Xmedia location. Example: For Lookbook will be:  'bundleComponent' it will be the same as the ItxxConstants xmediaLocations
 */
(function() {

    'use strict';
   
    var ItxProductViewCmp = {
        bindings: {
            product: '<',
            layout: '<',
            inBundleDialog: '<',
            imageSize: '<',
            imageType: '@',
            location: '<',
            place: '<',
            inViewport:'<',
            containerSelector:'<',
            dialog: '<',
            isLookbook: '<',
            noShowMiniCart: '<',
            doNotNavigate: '<',
            onProductClick: '&',
            hasSwiper: '<'
        },
        controller: ItxProductViewCmpCtrl,
        templateUrl: 'product-view.component.html'
    };

    angular.module('itxApp.common')
        .component('itxProductView', ItxProductViewCmp);

    ItxProductViewCmpCtrl.$inject = [
        'ItxConstants',
        'ItxScreenSizeSvc',
        'productPopupSvc',
        'ItxConfigurationSvc',
        'Category',
        'DUTTI_CONS',
        'CountryService',
        'ItxUtilsFct',
        'itxAkamaiSvc',
        'imGridService',
        '$scope',
        'mdUtils'
    ];

    function ItxProductViewCmpCtrl(
        ItxConstants,
        ItxScreenSizeSvc,
        productPopupSvc,
        ItxConfigurationSvc,
        Category,
        DUTTI_CONS,
        CountryService,
        ItxUtilsFct,
        itxAkamaiSvc,
        imGridService,
        $scope,
        mdUtils
    ){

        var _this = this;

        _this.debugActive = false;
        _this.swiperEnabled = false;
        _this.isMobile = ItxScreenSizeSvc.isMobile();
        _this.swiperOptions = {
            loop: true,
            speed: 600,
            direction: 'horizontal',
            slidesPerView: 1,
            noSwiping: true,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            //updateOnImagesReady: true,
            activeIndex: true
        };

        if(ItxConfigurationSvc.isDebugActive()){
            _this.debugActive = ItxConfigurationSvc.getDebugOptions().productInfo;
        }
        
        _this.$onDestroy = () => {
            _this.destroySwiper();
            _this.destroyMouseHover();
        };

        _this.$onInit = () => {
            if(!_this.layout){
                // LAYOUT DEFAULT
                _this.layout = ItxConstants.categoryLayout.FOUR_COLUMNS;
            }
            
            
            _this.XmediaLocation = ItxConstants.xmediaLocations[_this.location];

            if(_this.product.isVideo){
                _this.autoPlayVideo = _this.product.state.conf.autoPlayVideo;
                _this.playVideoAudio = !_this.product.state.conf.autoPlayVideo;
                _this.waitClick = _this.product.state.conf.waitClick;
            }

            if(_this.product.state.conf.navigate){
                _this.productUrl = _this.product.getUrl();
            } else {
                // SE DEBE PENSAR DE OTRO MODO
                // Para los nuevos productos de tipo banner por attachment
                // setTimeout(function (){
                //     $('#box_'+_this.product.id+' .product-view-image-wrapper a').css("cursor", "default");
                // }, 1);
            }
            _this.isExplorer = inditex.isExplorer();
            _this.setConfigCmp();
        };

        _this.$onChanges = changes => {
            if (changes.layout && !changes.layout.isFirstChange() && changes.layout.currentValue != changes.layout.previousValue) {
                _this.destroySwiper();
                _this.destroyMouseHover();
                _this.setConfigCmp();
            }
        };

        _this.setConfigCmp = () => {
            if(!_this.id){
                _this.id = _.uniqueId('box_'+_this.product.id+'_');
            }
            if(!_this.selectedColor){
                _this.selectedColor = _this.product.state.selectedColor;
            }
            
            _this.product.setLayout(_this.XmediaLocation);
            
            _this.enableVideo = _this.product.isVideo && (_this.layout == 'two-columns' || _this.isMobile); 
            let swiperDisabled = _this.location != 'categoryPage' || _this.product.state.isFakeBanner || _this.enableVideo;
            _this.rolloverEnabled = !_this.isMobile && !_this.product.config.isNoRollover && _this.location === 'categoryPage';
            _this.swiperEnabled = !_this.isMobile && !swiperDisabled && !_this.isExplorer && _this.product.layout[_this.layout].swiper;
            
            setTimeout(function() {
                if(_this.product.state.conf.options && !_this.isMobile){
                    _this.configMouseHover();       
                }
                _this.reloadPrimaryImage();
            }, 100);  
        };

        _this.configMouseHover = function() {
            _this.el = document.getElementById(_this.id);
            _this.elImage = document.getElementById(_this.id+'_image');
            _this.elDetails = document.getElementById(_this.id+'_details');
            _this.addEventJs(_this.el, 'mouseenter', _this.onMouseEnter);
        };

        _this.onMouseEnter = () => {
            _this.addEventJs(_this.el, 'mouseleave', _this.onMouseLeave);
            _this.addEventJs(_this.elImage, 'mouseenter', _this.onMouseEnterImage);
            _this.addEventJs(_this.elDetails, 'mouseenter', _this.onMouseEnterDetails);
        };

        _this.onMouseLeave = () => {
            _this.hideAddQuickly();
            _this.destroyEventsOnMouseEnter();
        };
        
        _this.destroyMouseHover = function() {
            _this.removeEventJs(_this.el,'mouseenter');
            _this.destroyEventsOnMouseEnter();
        };

        _this.destroyEventsOnMouseEnter = () =>{
            _this.removeEventJs(_this.elDetails, 'mouseenter');
            _this.removeEventJs(_this.el, 'mouseleave');
            _this.removeEventJs(_this.elImage, 'mouseenter');
            _this.removeEventJs(_this.elDetails, 'mouseenter');
            _this.addEventJs(_this.elImage, 'mouseleave');
        };
        
        _this.onMouseEnterImage = () => {
            _this.addEventJs(_this.elImage, 'mouseleave', _this.hideSwiper);
            _this.el.classList.add('is-active');
            _this.initSwiper();
        };

        _this.addEventJs = (el, name, callback) => {
            if(!el){
                return;
            }
            if(!callback) {
                callback = function(){};
            }
            el.addEventListener(name, callback);
        };

        _this.removeEventJs = (el, name, callback) => {
            if(!el){
                return;
            }
            if(!callback) {
                callback = function(){};
            }
            el.removeEventListener(name, callback);
        };

        _this.onMouseEnterDetails = () => {
            _this.el.classList.add('is-active-quickly');
        };
        
        _this.hideAddQuickly = () => _this.el.classList.remove('is-active-quickly');
        _this.hideSwiper = () => _this.el.classList.remove('is-active');
      
        _this.initSwiper = () => {
            if(!_this.swiperInit && _this.swiperEnabled && _this.rolloverEnabled){
                _this.el.classList.add('enable-swiper');
                _this.swiperInit = true;
            
                _this.swiperOptions.navigation = {
                    nextEl: '#' + _this.id + ' .ma-swiper-button-next',
                    prevEl: '#' + _this.id + ' .ma-swiper-button-prev'   
                };

                _this.swiperImages = _this.getImagesProduct(); 

                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.$digest();
                }

                setTimeout(function(){
                    _this.swiperObj = new Swiper('#' + _this.id + ' .swiper-container', _this.swiperOptions);
                },10);
            }
        };

        _this.destroySwiper = function(){
            if(_this.swiperObj){
                _this.swiperInit = false;
                _this.swiperObj.destroy();
            }
        };

        _this.reloadPrimaryImage = function() {
            if(!_this.product.layout) {
                return;
            };
            let widthEl = _getWidthElement(_this.id);
            
            _this.primaryImageSrc = _setAkamai(_this.product.layout[_this.layout].imageUrl, widthEl);
            if(_this.enableVideo){
                if(_this.product.layout[_this.layout].imageUrl.indexOf('.mp4') != -1 && _this.product.xmediaImages.length >= 2){
                    _this.primaryImageSrc = _this.product.xmediaImages[1].url;
                }
            }  
            _this.mainImage = _this.primaryImageSrc;
            if(_this.layout != 'two-columns' && _this.product.isVideo){
                _this.mainImage = _this.mainImage.replace('.mp4','.jpg');
            }

            if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                $scope.$digest();
            }
        };

        _this.colorChanged = function(color) {
            _this.onShowBulletPercentage(false);
            _this.swiperImages = [];
            _this.destroySwiper();
            _this.product.setColor(color);
            _this.selectedColor = color;
            _this.product.setLayout(_this.XmediaLocation);
            _this.reloadPrimaryImage();
        };

        _this.goToProductDetail = function($event) {
            if(_this.product.state.selectedColor && _this.product.state.selectedColor.id != _this.selectedColor.id){
                _this.product.setColor(_this.selectedColor);
            }

            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();    
            }

            if (_this.dialog) {
                productPopupSvc.openProductPopup(_this.product);
                imGridService.sendProductEvent(_this.product, _this.product.state.selectedColorIndex);
                return;
            }

            if(_this.product.state.isFakeBanner && _this.product.state.conf.navigateCustomId){
                window.location.href = Category.getCategoryUrl(_this.product.state.conf.navigateCustomId);
                imGridService.sendClickBanner(_this.product.state.conf.navigateCustomId)
                return;
            }    

            if(!_this.product.state.conf.navigate){
                return;
            }

            var productUrl = '',
                productId = _this.product.config && _this.product.config.id ? _this.product.config.id : _this.product.id;

            if (CountryService.is(DUTTI_CONS.country.CN) && !_this.isMobile) {
                window.open(_this.product.getUrl(), '_blank');
            } else {
                //Go to Product detail page
                inditex.setSessionStorage('BACK_TO_GRID_PRODUCT_' + inditex.iCategoryId, JSON.stringify({id: productId}) );
                    
                if (_this.onProductClick) {
                    var data = {
                        product: _this.product,
                        $color: _this.product.state.selectedColor,
                        $productUrl: productUrl
                    };
                    _this.onProductClick(data);
                }
            }
            if (_this.place === 'grid' || (_this.location === 'bundleComponent' && inditex.iPage === 'ItxCategoryPage' && !_this.product.isBundleBean)) {
                imGridService.sendProductEvent(_this.product, _this.product.state.selectedColorIndex);
            }
        };

        _this.getImagesProduct = () => {
            let widthEl = _getWidthElement(_this.id);
            let images = ItxUtilsFct.getProductXmediaImagesData(_this.product, ItxConstants.xmediaLocations['productPage'], widthEl);
        
            images = images.filter(filterImageDouble); 
            
            images.map(xmediaObj => xmediaObj.url = itxAkamaiSvc.useAkamaiProductImage(xmediaObj.url, widthEl))

            if (images && images[0] && images[0].url){
                let imageCatalog = cleanParams(_this.primaryImageSrc);
                let imageProduct = cleanParams(images[0].url);

                // Añadimos la imagen de parrilla para que no se note la transicion a Swiper si no existe ya en el producto
                if (imageProduct != imageCatalog) {
                    images.unshift({url:_this.primaryImageSrc});
                }
            }
            return images;
        }

        _this.onShowBulletPercentage = (percentage) => {
            _this.bulletPercentage = percentage;
        }
        
        var filterImageDouble = xmediaImg => { 
            return !(xmediaImg.clazz === 7);
        } 

        var cleanParams = url => {
            // url = url.split('_')[0];
            url = url.split('.jpg?')[0];
            url = url.substr(0,url.length-2);
            return url;
        }

        var _setAkamai = (img, width = 500) => {
            if(img){
                return itxAkamaiSvc.useAkamaiProductImage(img, width);
            } else {
                return _this.primaryImageSrc;
            }
        }

        var _getWidthElement = (id) => {
            let elementWidth = $('#'+id).width();
            if(!elementWidth || elementWidth < 400) {
                return 400;
            } else {
                return elementWidth;
            }
        };
    }

})();